import React, { PropsWithChildren } from 'react';

export const LocationDropdown: React.FC<PropsWithChildren<{ isFloating?: boolean }>> = ({ children, isFloating = true }) => {
  return (
    <div
      className={`z-20 size-full min-w-67 flex-col space-y-2 overflow-auto rounded-2 bg-bg-primary py-3 lg:top-12 lg:flex lg:h-auto lg:max-h-select lg:p-3 lg:shadow-md ${isFloating ? 'lg:absolute' : ''}`}
    >
      {children}
    </div>
  );
};
